export default class DatatypeHelper {

  static toBoolean(value) {
    if (value) {
      switch (value) {
        case true:
        case "true":
        case 1:
        case "1":
          return true;
        default:
          return false;
      }
    }
    return false
  }
}
